import React from 'react';
import Translator from '../../requests/apa/Translator';
import Utils from '../../utils/Utils';
import './episodeInfo.scss';

const EpisodeInfo = ({episodeNumber, title, description = ''}) => {
    return (
        <div className="episode-info">
            <div className="episode-info-number">{`${Translator.get('vcard_access_abbreviationEpisode_label','Episodio')} ${episodeNumber}`}</div>
            <div className="episode-info-title">{`${Utils.cutPlayerString(title,34)}`}</div>
            <div className="episode-info-description">{`${Utils.cutPlayerString(description,122)}`}</div>
        </div>
    );
}

EpisodeInfo.defautProps = {
    episodeNumber:'',
    title: '',
    description:''
}

export default EpisodeInfo;



// WEBPACK FOOTER //
// ./src/components/Card/EpisodeInfo.jsx